import { Globals } from '@bwoty-web/ui-kit';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import ComboSummaryContainer from './containers/ComboSummaryContainer';
import { createComboSummaryStore } from './redux/store/comboSummaryStore';

const initialState = window.__INITIAL_STATE_IW_COMBO_SUMMARY__;
delete window.__INITIAL_STATE_IW_COMBO_SUMMARY__;

if (initialState) {
  const comboSummaryStore = createComboSummaryStore(initialState);
  const { siteSettings } = initialState;

  const root = createRoot(document.getElementById('iw-combo-summary'));
  root.render(
    <Globals
      siteId={siteSettings?.siteId || 1}
      legacyMode={siteSettings?.legacyMode}
    >
      <Provider store={comboSummaryStore}>
        <ComboSummaryContainer />
      </Provider>
    </Globals>,
  );
}
